import { IUnit } from './types';
import { createUnitHook } from '../ui/create-unit-hook';
/**
 * You can use multiples and divisors of unit for the margin and paddings.
 * Ex: useUnit(2) or useUnit(0.5) or etc.
 *
 * The reason behind defining constants as function that emotion can invoke them into templete string.
 */

export const unit: IUnit = (multiplier) => ({ theme }): number => {
  return multiplier ? theme.unitSize * multiplier : theme.unitSize;
};

unit.px = (multiplier) => ({ theme }): string => {
  return multiplier ? `${theme.unitSize * multiplier}px` : `${theme.unitSize}`;
};

export const useUnit = createUnitHook(unit);
/**
 * They just represent specific numbers for height of inputs, buttons or list items etc.
 */
export const itemHeight: IUnit = () => ({ theme }) => theme.itemHeight;
itemHeight.px = () => ({ theme }) => `${theme.itemHeight}px`;
export const useItemHeight = createUnitHook(itemHeight);

export const itemCompactHeight: IUnit = () => ({ theme }) =>
  theme.itemCompactHeight;
itemCompactHeight.px = () => ({ theme }) => `${theme.itemCompactHeight}px`;
export const useItemCompactHeight = createUnitHook(itemCompactHeight);

export const itemSmallHeight: IUnit = () => ({ theme }) =>
  theme.itemSmallHeight;
itemSmallHeight.px = () => ({ theme }) => `${theme.itemSmallHeight}px`;
export const useItemSmallHeight = createUnitHook(itemSmallHeight);

export const layers = {
  card: () => 100,
  dialog: () => 300,
  navigation: () => 200,
  layer: () => 400,
  blanket: () => 500,
  modal: () => 510,
  flag: () => 600,
  spotlight: () => 700,
  tooltip: () => 800,
};

export const borderRadius: IUnit = () => ({ theme }) => theme.borderRadius;
borderRadius.px = () => ({ theme }) => `${theme.borderRadius}px`;
export const useBorderRadius = createUnitHook(borderRadius);
